DealsApplication = require '../application'

module.exports = class PaginatedDealsBuilder
  constructor: ({@omitSearch} = {}) ->
    @events = _.clone Backbone.Events

    @search = new DealsApplication(@_searchOptions())

    @search.on 'error', @triggerFetchError
    @search.on 'success', @triggerFetchSuccess

  _searchOptions: ->
    if Groupon.onNoDealsPage
      unfiltered: true
    else
      _.omitUndefined
        omitSearch: @omitSearch

  triggerFetchError: =>
    @events.trigger 'fetchError'
    @events.stopListening()

  triggerFetchSuccess: =>
    $ =>
      @events.trigger 'fetchSuccess', @search
      @events.stopListening()

  on: ->
    @events.on arguments...
